module.exports = __webpack_public_path__ + "static/img/xt03.2cbc84e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xt03.png
// module id = vWZD
// module chunks = 0